<template>
  <div class="">
    <salesmen-create> </salesmen-create>
  </div>
</template>

<script>
import SalesmenCreate from "@/components/profile/brokers/agency-brokers/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    SalesmenCreate,
  },
  created() {
    this.notifyQueue({
      text: "Produttori di Agenzia",
      path: "module.PROF.PRCO",
      tab: "#AgencyBrokers",
      level: 3,
    });
    this.notifyQueue({
      text: "Crea Produttore di Agenzia",
      path: "brokers.create2",
      level: 4,
    });
  },
};
</script>
